<template>
  <div class="loan-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar :title="$route.query.name" url="/home" />
    </div>
    
    <!--贷款列表-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div>
      <template v-if="loading">
      <template v-if="article.data">
      <div class="van-card" v-for="item in filterBy(article.data,city)">
        <div class="van-card__header" @click="goUrl('/loan/detail/'+item.id)">
          <a class="van-card__thumb">
            <div class="van-image" style="width: 100%; height: 100%;">
              <img :src="uploadsUrl+item.picture" class="van-image__img" style="object-fit: cover;">
            </div>
          </a>
          <div class="van-card__content">
            <div>
              <div class="van-card__title van-multi-ellipsis--l2">{{item.title}}</div>
              <div class="van-card__desc van-ellipsis">适合人群：{{item.shiheren}}</div>
              <div class="van-card__desc van-ellipsis">可款额：{{item.kedaie}}</div>
              <div class="van-card__desc van-ellipsis">基本要求：{{item.jibenyaoqiu}}</div>
              <div class="van-card__desc van-ellipsis">贷款利息：{{item.daikuanlirun}}元/万元/月</div>
            </div>
          </div>
        </div>
        <div class="van-card__footer">
          <button class="van-button van-button--default van-button--small" style="background-color: #ff8917; color: #fff;" @click="goUrl('/loan/detail/'+item.id)">
            <div class="van-button__content">
              <span class="van-button__text">详情</span>
            </div>
          </button>
        </div>
      </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#ff8917" vertical />
      </template>
    </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'LoanList',
    data() {
        return {
            isLoading: false,
            loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            article: state => state.article.article_list
        })
    },
    methods: {
        ...mapActions(['requestArticle']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
    },
    components: {
      NavBar
    },
    mounted() {
      this.requestArticle({"thit":this,"category":this.$route.params.id,"city":this.city});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
